import React from 'react';
import { Icon, Modal } from '@instinet-analytics/semantic-ui-components';
import { SymbolInfo } from 'symbols/symbolInfo/symbolInfoSlice';
import { SymbolInfoDisplay } from 'symbols/symbolInfo/SymbolInfoDisplay';
import './SymbolInfoDisplayModal.scss';

export function SymbolInfoDisplayModal(props: {
    info: SymbolInfo | undefined;
    trigger?: JSX.Element;
}) {
    const { info, trigger } = props;

    if (!info) {
        return <></>;
    }

    return (
        <Modal
            className="SymbolInfoDisplayModal"
            trigger={
                trigger ?? (
                    <Icon
                        name="info"
                        className="SymbolInfoDisplayModalTrigger"
                    />
                )
            }
            headerText={'Symbol Info'}
            onSave={() => {
                return;
            }}
            saveText={'OK'}
        >
            <SymbolInfoDisplay info={info} />
        </Modal>
    );
}
